import React from 'react';
import { useTranslation } from "react-i18next";
import Styles from "../../../scss/discounts.module.scss"
export  function DiscountStatus({enabled,key}:{enabled:boolean,key:any}) {
  const { t } = useTranslation();
  return (
    <span>
          <span key={key} className={enabled?Styles.enabled:Styles.disabled}>{ enabled ? t(`discounts.discountsContainer.active`):t(`discounts.discountsContainer.inactive`)}</span>
    </span>
  )
}
